import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './VideoQualityCrfInput.scss';
import { TextInput } from '../../FormComponents/TextInput/TextInput';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoQualityCrfInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const [ crf, setCrf ] = useState<number>(project.encoder.transcoderVideoQualityCrf);
  const debounce = 100;
  const min = 18;
  const max = 28;

  const onAfterChange = (data: string) => {
    if (project.encoder) {
      let value = crf;

      if (value < min) {
        value = min;
      } else if (value > max) {
        value = max;
      }

      setCrf(value);

      if (project.stream.sourceLanguageIsoCode === project.encoder.languageIsoCode) {
        updateStream({
          transcoderVideoQualityCrf: value,
        }, debounce);
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoQualityCrf: value,
        }, debounce);
      }
    }
  };

  useEffect(() => {
    setCrf(project.encoder.transcoderVideoQualityCrf);
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [project.encoder.transcoderVideoQualityCrf]);

  return (
    <div className="video-quality-crf-input">
      <div className="input-title">
        {t('producer.inputs.video-quality-crf.title')}
        <Help
          title="Quality CRF"
          text="Quality CRF (Constant Rate Factor) controls the overall visual quality of your video stream.<br/><br/>- Lower CRF values produce higher quality video with larger file sizes.<br/>- Higher CRF values reduce file size but may decrease visual quality.<br/>- Adjust this setting to balance image clarity with bandwidth and storage requirements.<br/><br/>This is useful when you want consistent visual quality rather than a fixed bitrate."
        />
      </div>
      <TextInput
        placeholder="producer.inputs.video-quality-crf.placeholder"
        value={crf.toString()}
        onChange={(value) => {setCrf(parseInt(value))}}
        onAfterChange={onAfterChange}
        validate={false}
        number={true}
      />
      <button className="btn btn-apply btn-secondary btn-no-margin btn-margin-right" type="button">Apply</button>
      <div className="input-component-footer">{t('producer.inputs.video-quality-crf.footer')}</div>
    </div>
  );
};

export default React.memo(VideoQualityCrfInput);
